export const validateMobile = (phoneNumber) => {
    return !Boolean(phoneNumber) ||
        Boolean(phoneNumber.match(/^\d{6}$/)) ||
        Boolean(phoneNumber.match(/^(\+7|8)\d{10}$/));
};

export const validatePassword = (value) => {
    return /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])/.test(value)
};